import { useMemo, useCallback } from 'react'
import { ControlPosition } from '@vis.gl/react-google-maps'

export const useLocationDerivedState = (latitude, longitude) => {
  const isValidCoord = useCallback(value => typeof value === 'number' && !Number.isNaN(value), [])

  const centerLatLng = useMemo(() => ({ lat: latitude, lng: longitude }), [latitude, longitude])

  const showCenterElements = useMemo(() => isValidCoord(latitude) && isValidCoord(longitude), [latitude, longitude, isValidCoord])

  const zoomControlOptions = useMemo(() => ({ position: ControlPosition.TOP_LEFT }), [])

  return { centerLatLng, showCenterElements, zoomControlOptions, isValidCoord }
}
